import { WalletId } from '@/api/wallets/types';
import { CachedWithdrawalData, ReceiverBankFromAPI } from '@/api/withdrawal/types';
import { ApiTransactionAPIModelStatusEnum as TransactionAPIModelStatusEnum } from '@/generated/api/fps/core';
import { BankId, MessageId, MoneyType, PhoneType, TransactionId, Value } from '@/model/common';

export type { CachedWithdrawalData, WalletId };

export const NAMESPACE = 'WITHDRAWAL';

export type ReceiverBank = {
  id: string;
  name: string;
  bankIcon: string;
  bankId?: BankId;
}

export enum WithdrawalStep {
  Phone = 'Phone',
  Prepare = 'Prepare',
  Transfer = 'Transfer',
  Running = 'Running',
  Finished = 'Finished',
}

export enum WithdrawalUIState {
  RECEIVER = 'receiver',
  PREPARE = 'prepare',
  TRANSFER = 'transfer',
  STATUS = 'status',
}

export interface WithdrawalReceiver {
  phone: PhoneType;
  name?: string;
  priorityBank?: string;
}

export interface WithdrawalForm {
  id: MessageId;
  receiver: WithdrawalReceiver;
  receiverBanks: ReceiverBankFromAPI[];
  amount?: Value<MoneyType>;
  bank?: Value<BankId>;
  wallet?: Value<WalletId>;
  message?: Value<string>;
  fee?: MoneyType;
  createdAt?: Date;
}

export interface TransferFormDataCache {
  amount?: MoneyType;
  bank?: BankId;
  wallet?: WalletId;
  message?: string;
}

export interface Timing {
  nextAllowedAt: Date;
  expiresAt: Date;
}

export interface State {
  initialized: boolean;
  status?: TransactionAPIModelStatusEnum;
  sbpId?: string;
  transactionId?: TransactionId;
  phone?: Value<PhoneType>;
  formData?: WithdrawalForm;
  cache?: TransferFormDataCache;
  timing?: Timing;
  step?: WithdrawalStep;
  running?: boolean;
}

export const initialState: State = {
  initialized: false,
};
